/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface PersonRelationRef
 */
export interface PersonRelationRefOptional {
  /**
   *
   * @type {number}
   * @memberof PersonRelationRef
   */
  relationId?: number;
}

export interface PersonRelationRef extends PersonRelationRefOptional {
  /**
   *
   * @type {number}
   * @memberof PersonRelationRef
   */
  relationId: number;
}

export interface PersonRelationRefTrackedI {
  /**
   *
   * @type {number}
   * @memberof PersonRelationRef
   */
  relationId?: number;
  relationIdIsSet: boolean;
}

transformDatesMap.set(
  "PersonRelationRef",
  function (model: PersonRelationRef) {},
);

export type PersonRelationRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  relationId: PropertyMeta<MetaTypeBase<number>>;
}>;

export var PersonRelationRefMeta: PersonRelationRefMetaI =
  {} as PersonRelationRefMetaI;
PersonRelationRefMeta = typeMeta("PersonRelationRef", {
  relationId: propertyMeta(
    "relationId",
    false,
    true,
    true,
    MetaTypesBase.number,
  ),
});

const metaI = PersonRelationRefMeta;

registerMeta(() => {});

export class PersonRelationRefTracked implements PersonRelationRefTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  relationId__I?: number = undefined;

  get relationIdIsSet() {
    return this.relationId !== undefined;
  }
  set relationIdIsSet(v: boolean) {}
  set relationId(v: undefined | number) {
    if (v !== undefined) {
      this.relationId__I = v;
      this.relationIdIsSet = true;
    } else {
      this.relationId__I = v || undefined;
      this.relationIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get relationId() {
    return this.relationId__I;
  }
  constructor(config?: PersonRelationRefOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.relationIdIsSet == true && other?.relationIdIsSet == true)
      return this.relationId == other.relationId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.relationId) {
      this.relationIdIsSet = true;
    }
  }
  assignFrom(
    config: PersonRelationRefOptional,
    options?: AssignOptions,
  ): PersonRelationRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.relationId &&
      this.relationIdApplyFilter(optionsRequired.filter)
    ) {
      this.relationId = config.relationId;
      if (optionsRequired.unassign) this.relationIdIsSet = false;
      else this.relationIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonRelationRefTrackedI {
    const cloned = {} as PersonRelationRefTrackedI;
    if (
      this.relationIdIsSetDeep() &&
      this.relationIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.relationIdIsSet = true;
      cloned.relationId = this.relationId;
    } else {
      //cloned.relationIdIsSet = false
    }
    if (!isDeleted(this) && !this.relationIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonRelationRefTrackedI {
    if (!this.relationIdApplyFilter(filter)) this.relationIdIsSet = false;

    return this;
  }
  relationIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonRelationRefMeta.relationId,
      PersonRelationRefMeta,
      this.relationId,
      this,
    );
  }
  relationIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.relationIdIsSet && this.relationIdApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.relationIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
